"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tableMock = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
const tableMock = exports.tableMock = {
    __typename: 'TableModule',
    title: 'Table Module Example',
    description: 'This is an example of a table module with multiple rows and columns.',
    id: '007c1856-faf2-4814-8723-b5144341d9f4',
    editorialContentType: _editorialFetching.EditorialContentType.Table,
    columnDefinitions: [
        {
            key: 'name',
            label: 'Name'
        },
        {
            key: 'age',
            label: 'Age'
        },
        {
            key: 'city',
            label: 'City'
        },
        {
            key: 'picture',
            label: 'Profile Picture'
        }
    ],
    rows: [
        {
            cells: [
                {
                    columnKey: 'name',
                    // value: 'Ondra Breberů',
                    value: {
                        text: 'Ondra Breberů'
                    }
                },
                {
                    columnKey: 'age',
                    // value: '69',
                    value: {
                        text: '69'
                    }
                },
                {
                    columnKey: 'city',
                    value: {
                        text: 'Ústí nad Labem'
                    }
                },
                {
                    columnKey: 'picture',
                    value: {
                        text: '<img src="https://www.transparentnivolby.cz/prezident2013/wp-content/uploads/zeman_vyrez.jpg" alt="Profile Picture" style="width: 50px; height: 50px; border-radius: 50%;" />'
                    }
                }
            ]
        },
        {
            cells: [
                {
                    columnKey: 'name',
                    value: {
                        text: 'Jane Smith'
                    }
                },
                {
                    columnKey: 'age',
                    value: {
                        text: '25'
                    }
                },
                {
                    columnKey: 'city',
                    value: {
                        text: 'Los Angeles'
                    }
                }
            ]
        },
        {
            cells: [
                {
                    columnKey: 'name',
                    value: {
                        text: 'Alice Johnson'
                    }
                },
                {
                    columnKey: 'age',
                    value: {
                        text: '28'
                    }
                },
                {
                    columnKey: 'city',
                    value: {
                        text: 'Nedakonice'
                    }
                }
            ]
        },
        {
            cells: [
                {
                    columnKey: 'name',
                    value: {
                        text: 'Bob Brown'
                    }
                },
                {
                    columnKey: 'age',
                    value: {
                        text: '22'
                    }
                },
                {
                    columnKey: 'city',
                    value: {
                        text: 'Olomóc'
                    }
                }
            ]
        }
    ]
};
